<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Nav">
	<div
		class="menu-container menu-container-v2"
		[class.menu-container-v2--collapsed]="allowNavigation !== true"
		*ngLet="allowNavigation$ | async as allowNavigation"
	>
		<div class="logo-container-v2">
			<ion-icon src="assets/svg/rideops-logo-v2.svg" class="logo-v2"></ion-icon>
		</div>

		<ng-container *ngLet="currentUrl$ | async as currentUrl">
			<div class="nav-items-v2">
				<a
					class="nav-item-v2"
					[class.active]="currentUrl === '/dashboard'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/dashboard']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__DASHBOARD' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">dashboard</span>
					<span class="nav-label">{{ "MENU_BAR__DASHBOARD" | transloco }}</span>
				</a>

				<a
					class="nav-item-v2"
					[class.active]="currentUrl === '/operators'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/operators']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__STAFFING' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">person</span>
					<span class="nav-label">{{ "MENU_BAR__STAFFING" | transloco }}</span>
				</a>

				<a
					class="nav-item-v2"
					[class.active]="currentUrl === '/manuals'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/manuals']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__MANUALS' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">auto_stories</span>
					<span class="nav-label">{{ "MENU_BAR__MANUALS" | transloco }}</span>
				</a>

				<a
					*ngIf="showNotesIcon$ | async"
					class="nav-item-v2 menu-bar-notes-v2"
					[class.active]="currentUrl === '/notes'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/notes']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__NOTES' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">news</span>
					<span class="nav-label">{{ "MENU_BAR__NOTES" | transloco }}</span>
					<ng-container *ngIf="pendingHandoverAcknowledgements$ | async as pendingAck">
						<ion-badge *ngIf="pendingAck > 0" class="menu-bar-notes-badge-v2">{{ pendingAck }}</ion-badge>
					</ng-container>
				</a>

				<a
					class="nav-item-v2"
					[class.active]="currentUrl === '/activities'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/activities']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__ACTIVITIES' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">view_timeline</span>
					<span class="nav-label">{{ "MENU_BAR__ACTIVITIES" | transloco }}</span>
				</a>

				<a
					*ngIf="allowStatisticsForOperator$ | async"
					class="nav-item-v2"
					[class.active]="currentUrl === '/statistics'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/statistics']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__STATISTICS' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">timeline</span>
					<span class="nav-label">{{ "MENU_BAR__STATISTICS" | transloco }}</span>
				</a>
			</div>

			<div class="nav-footer-v2">
				<app-environment-bar></app-environment-bar>
				<a
					class="nav-item-v2"
					[class.active]="currentUrl === '/settings'"
					[class.disabled]="allowNavigation !== true"
					[routerLink]="['/settings']"
					routerDirection="root"
					[attr.aria-label]="'MENU_BAR__SETTINGS' | transloco"
				>
					<span class="material-symbols-outlined material-symbols-outlined--size-32">settings</span>
					<span class="nav-label">{{ "MENU_BAR__SETTINGS" | transloco }}</span>
				</a>
			</div>
		</ng-container>
	</div>
</ng-container>

<ng-template #v1Nav>
	<div class="menu-container" *ngLet="allowNavigation$ | async as allowNavigation">
		<div class="icon-container">
			<ion-icon src="assets/svg/rideops-logo.svg" class="logo" (click)="settings()"></ion-icon>
		</div>

		<ng-container *ngLet="currentUrl$ | async as currentUrl">
			<div
				class="icon-container"
				[ngClass]="{
					active: currentUrl === '/dashboard',
					disabled: allowNavigation !== true,
				}"
			>
				<ion-icon name="albums-outline" [routerLink]="['/dashboard']" routerDirection="root"></ion-icon>
			</div>

			<div
				class="icon-container"
				[ngClass]="{
					active: currentUrl === '/operators',
					disabled: allowNavigation !== true,
				}"
			>
				<ion-icon name="person-outline" [routerLink]="['/operators']" routerDirection="root"></ion-icon>
			</div>

			<div
				class="icon-container"
				[ngClass]="{
					active: currentUrl === '/manuals',
					disabled: allowNavigation !== true,
				}"
			>
				<ion-icon name="book-outline" [routerLink]="['/manuals']" routerDirection="root"></ion-icon>
			</div>

			<div
				*ngIf="showNotesIcon$ | async"
				class="icon-container menu-bar-notes"
				[ngClass]="{
					active: currentUrl === '/notes',
					disabled: allowNavigation !== true,
				}"
			>
				<ion-icon name="document-text-outline" [routerLink]="['/notes']" routerDirection="root"></ion-icon>
				<ng-container *ngIf="pendingHandoverAcknowledgements$ | async as pendingAck">
					<ion-badge *ngIf="pendingAck > 0" class="menu-bar-notes-badge">{{ pendingAck }}</ion-badge>
				</ng-container>
			</div>

			<div
				class="icon-container"
				[ngClass]="{
					active: currentUrl === '/activities',
					disabled: allowNavigation !== true,
				}"
			>
				<ion-icon name="cog-outline" [routerLink]="['/activities']" routerDirection="root"></ion-icon>
			</div>

			<div
				class="icon-container"
				*ngIf="allowStatisticsForOperator$ | async"
				[ngClass]="{ disabled: allowNavigation !== true }"
			>
				<ion-icon name="analytics-outline" (click)="statistics()"></ion-icon>
			</div>

			<div class="icon-container mobaro">
				<ion-icon src="assets/svg/mobaro-logo.svg" class="logo"></ion-icon>
			</div>
		</ng-container>
	</div>
</ng-template>
